export default __webpack_public_path__ + "static/The Home_Image 4_carousel 6@2x-b73089bfe5a374c62854ecc0c2ba4bb1.jpg";